/* @flow */
/* eslint-disable max-statements */
import produce from 'immer'
import { validation } from './Feature28.consts'

export default function reducer(
  state: typeof meta.defaultProps = initialState,
  action: any
) {
  const initialState = action.__initialData.defaultProps
  return produce(state, draft => {
    switch (action.type) {
      case 'CHANGE_TITLE':
        draft.title = action.value
        break
      case 'CHANGE_PARAGRAPH':
        draft.paragraph = action.value
        break
      case 'CHANGE_TITLE_ALIGNMENT': {
        draft.titleAlignment = action.value
        break
      }
      case 'CHANGE_PARAGRAPH_ALIGNMENT': {
        draft.paragraphAlignment = action.value
        break
      }

      case 'REMOVE_BACKGROUND_IMAGE':
        draft.backgroundImgUrl = ''
        draft.backgroundImgDimensions = {}
        break
      case 'CHANGE_BACKGROUND_IMAGE':
        const { url, dimensions } = action.value
        draft.backgroundImgUrl = url
        draft.backgroundImgDimensions = dimensions
        break
      case 'CHANGE_BG_OVERLAY_TRANSPARENCY':
        draft.bgOverlayTransparency = action.value
        break
      case 'ADD_BLOCK':
        draft.slides.push(initialState.slides[0])
        break
      case 'REMOVE_BLOCK': {
        const { idx } = action.value
        draft.slides.splice(idx, 1)
        break
      }
      case 'CHANGE_MENU_TITLE': {
        const { idx, newTitle } = action.value
        draft.slides[idx].title = newTitle
        break
      }

      case 'CHANGE_SLIDER_TITLE': {
        const { newSliderTitle, idx } = action.value
        draft.slides[idx].sliderTitle = newSliderTitle
        break
      }

      case 'CHANGE_SLIDER_PARAGRAPH': {
        const { newSliderParagraph, idx } = action.value
        draft.slides[idx].sliderParagraph = newSliderParagraph
        break
      }

      case 'CHANGE_SLIDER_TITLE_ALIGNMENT': {
        const { alignment, idx } = action.value
        draft.slides[idx].sliderTitleAlignment = alignment
        break
      }
      case 'CHANGE_SLIDER_PARAGRAPH_ALIGNMENT': {
        const { alignment, idx } = action.value
        draft.slides[idx].sliderParagraphAlignment = alignment
        break
      }

      case 'CHANGE_BLOCK_TITLE': {
        const { newBlockTitle, idx } = action.value
        draft.slides[idx].blockTitle = newBlockTitle
        break
      }

      case 'CHANGE_BLOCK_VALUE': {
        const { newBlockValue, idx } = action.value
        draft.slides[idx].blockValue = newBlockValue
        break
      }

      case 'CHANGE_SUBBLOCK_TITLE': {
        const { newSubBlockTitle, activeIdx, itemIdx } = action.value
        draft.slides[activeIdx].subBlocks[itemIdx].subBlockTitle =
          newSubBlockTitle
        break
      }

      case 'CHANGE_SUBBLOCK_VALUE': {
        const { newSubBlockValue, activeIdx, itemIdx } = action.value
        draft.slides[activeIdx].subBlocks[itemIdx].subBlockValue =
          newSubBlockValue
        break
      }

      case 'ADD_SUBBLOCK_ITEM': {
        draft.slides[action.value].subBlocks.push(
          initialState.slides[0].subBlocks[0]
        )
        break
      }

      case 'REMOVE_SUBBLOCK_ITEM': {
        const { idx: idx__, activeIdx: activeIdx__ } = action.value
        if (
          state.slides[idx__].subBlocks.length ===
          validation.slides.subBlocks.min
        ) {
          return
        }
        draft.slides[idx__].subBlocks.splice(activeIdx__, 1)
        break
      }
      case 'CHANGE_ICON':
        {
          const { idx, iconName } = action.value
          draft.slides[idx].iconName = iconName
        }
        break
      case 'REMOVE_ICON': {
        const { idx } = action.value
        draft.slides[idx].iconName = ''
        break
      }
      case 'ADD_ICON':
        draft.slides[action.value].iconName = initialState.slides[0].iconName
        break
      case 'REMOVE_IMAGE_BLOCK': {
        const { idx } = action.value
        draft.slides[idx].imgUrl = ''
        draft.slides[idx].imgDimensions = {}
        break
      }

      case 'ADD_IMAGE_BLOCK': {
        const { idx } = action.value
        draft.slides[idx].imgUrl = initialState.slides[0].imgUrl
        draft.slides[idx].imgDimensions = initialState.slides[0].imgDimensions
        break
      }
      case 'CHANGE_IMAGE':
        {
          const { idx, url, dimensions } = action.value
          draft.slides[idx].imgUrl = url
          draft.slides[idx].imgDimensions = dimensions
          draft.slides[idx].imgCropParams = {}
        }
        break
      case 'SET_IMG_CROP_PARAMS': {
        const { imgCropParams, idx } = action.value
        draft.slides[idx].imgCropParams = imgCropParams
      }
    }
  })
}
